'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var FieldValue = require('utils/field_value');

var maxDeviceCount = 10;

function nextColor(src) {
    var usedColors = {};
    var defaultColors = Misc.getPickerDefaultColors();
    _.each(src, function (item) {
        usedColors[item.color] = true;
    });
    var selectedColor = undefined;
    _.each(defaultColors, function (item) {
        if (!usedColors[item]) selectedColor = selectedColor || item;
    });
    return selectedColor || defaultColors[0];
}

function getSeriesRow(e) {
    if (e.currentTarget) return getSeriesRow(e.currentTarget);

    var $row = $(e).closest('div.js-series-row');
    return {
        row: $row,
        idx: parseInt($row.attr('data-idx')),
        find: function (what) {
            return this.row.find(what);
        },
    };
}

function getSeriesCondRow(e) {
    if (e.currentTarget) return getSeriesCondRow(e.currentTarget);

    var $row = $(e).closest('div.js-cond-row');
    return {
        row: $row,
        idx: parseInt($row.attr('data-idx')),
        find: function (what) {
            return this.row.find(what);
        },
        series: getSeriesRow(e),
    };
}

function getSeriesIdx(e) {
    var s = getSeriesRow(e);
    return s.idx;
}

function toDeviceColorMap(src) {
    var result = {};
    _.each(src, function (c, devID) {
        result[devID] = c && c.replace(/[^\d,]/g, '');
    });
    return result;
}

function deviceColorMapFrom(src) {
    var result = {};
    _.each(src, function (c, devID) {
        result[devID] = 'rgb(' + c + ')';
    });
    return result;
}

function hasAggregation(value, cols) {
    cols = cols || AppState.uniqueFields();
    return (
        Misc.countWhere(
            cols,
            function (item) {
                return item.id == value && item.fieldGroup == Consts.FieldGroup.Data;
            },
            false
        ) > 0
    );
}

var FilterSelectWizardView = require('components/devices/views/common/filter_select_wizard_view');

var DeviceReportDialogView = OOP.extend(
    FilterSelectWizardView,
    {
        template: require('components/profile/templates/device_report_content_dialog'),
        fieldValuesEnum: {},

        initialize: function (options) {
            this.base.initialize(options);
            this.model = options.model;
            var filter = Misc.cloneAsJSON(this.model.get('filter') || {});
            this.filterIntf = this.installFilter({
                filter: filter,
                selection: filter.selection,
            });
            this.cb = options.cb;

            var fields = AppState.uniqueFields();
            var usedColors = [];
            this.data = {
                name: options.model.get('name'),
                description: options.model.get('description'),
                sortdesc: options.model.get('sort_desc'),
                sortcol: options.model.get('sort_col'),
                limit: options.model.get('limit'),
                series: _.map(options.model.get('fields'), function (row) {
                    var customConditions = _.map(row.display_values, function (item) {
                        return {
                            text: item.text,
                            value: item.value,
                            op: item.op,
                            color:
                                (item.color || '') != ''
                                    ? 'rgb(' + item.color + ')'
                                    : (function () {
                                          var color = nextColor(usedColors);
                                          usedColors.push({ color: color });
                                          return color;
                                      })(),
                        };
                    });
                    return {
                        id: row.id,
                        name: row.name,
                        unit: row.unit,
                        aggregation: row.aggregation,
                        value: row.value,
                        hasAggregation: hasAggregation(row.value, fields),
                        mode: row.mode,
                        customConditions: customConditions,
                        customCond: customConditions.length > 0,
                        deviceColorMap: deviceColorMapFrom(row.device_color_map),
                    };
                }),
                report: {
                    name: options.model.get('name'),
                },
            };

            if (options.model.id) {
                this.wizardConfig.onFilterDevicesDone = function () {
                    if (!this.wizardConfig.deviceReportContentDevicesNext) {
                        this.wizardConfig.deviceReportContentDevicesNext = true;
                        this.tryWizardNext();
                    }
                };

                this.wizardConfig.onFilterSelectionDone = function () {
                    if (!this.wizardConfig.deviceReportContentSelectionNext) {
                        this.wizardConfig.deviceReportContentSelectionNext = true;
                        this.tryWizardNext();
                    }
                };
            }
        },

        ui: {
            edtName: 'input.js-name',
            edtDescription: '#report-part-description',
            chkIsActive: '#is-active',
            ddlReportPeriod: 'select.js-report-period',
            ddlReportFormat: 'select.js-report-format',
            rbtReceiverMe: '#js-receiver-me',
            rbtReceiverOther: '#js-receiver-other',
            ddlMailingList: 'select#js-mailing-list',
        },

        events: OOP.inheritedObj('events', {
            'click .js-delete-series': function (e) {
                this.data.series.splice(getSeriesIdx(e), 1);
                this.data.selectedSeriesRow = undefined;
                this.render();
            },
            'click .js-series-up': function (e) {
                var idx = getSeriesIdx(e);
                var tmp = this.data.series[idx - 1];
                if (!tmp) return;
                this.data.series[idx - 1] = this.data.series[idx];
                this.data.series[idx] = tmp;
                this.data.selectedSeriesRow = idx - 1;
                this.render();
            },
            'click .js-series-down': function (e) {
                var idx = getSeriesIdx(e);
                var tmp = this.data.series[idx + 1];
                if (!tmp) return;
                this.data.series[idx + 1] = this.data.series[idx];
                this.data.series[idx] = tmp;
                this.data.selectedSeriesRow = idx + 1;
                this.render();
            },
            'click .js-add-series': function (e) {
                var self = this;
                var cols = Misc.selectWhere(AppState.uniqueFields(), function (item) {
                    return true;
                });
                var series = {
                    mode: 0,
                    aggregation: Consts.Aggregation[0].id,
                    value: cols[0].id,
                    hasAggregation: cols[0].fieldGroup == Consts.FieldGroup.Data,
                };

                // locate a mode that is not "global" (so we won't do unwanted changes at other fields)
                _.each(Consts.DeviceReportModeProp, function (x, key) {
                    if (!x.isGlobal) {
                        series.mode = parseInt(key);
                    }
                });

                this.setSeriesDefaultName(series);
                this.data.series.push(series);
                this.data.selectedSeriesRow = this.data.series.length - 1;
                this.render();
            },
            'change select.js-edit-series': function (e) {
                this.saveSeriesRow(e, true);
                this.render();
            },
            'click .js-edit-series-render': function (e) {
                this.saveSeriesRow(e);
                this.render();
            },
            'focusout input.js-edit-series.js-name': function (e) {
                this.saveSeriesRow(e, false);
                this.render();
            },
            'change select.js-edit-sorting': function (e) {
                this.saveSorting(e);
                this.render();
            },
            'click input.js-edit-sorting': function (e) {
                this.saveSorting(e);
                this.render();
            },
            'focusout input.js-limit': function (e) {
                this.saveSorting(e);
                this.render();
            },
            'keyup input.js-edit-series': function (e) {
                this.saveSeriesRow(e);
                this.updateWizardButtons();
            },
            'click .js-edit-series-mode': function (e) {
                this.saveSeriesRow(e, true, true);
            },
            'change select.js-edit-series-mode': function (e) {
                this.saveSeriesRow(e, true, true);
                this.render();
            },
            'keyup .js-name': function (e) {
                this.data.name = this.ui.edtName.val();
                this.updateWizardButtons();
            },
            'keyup #report-part-description': function (e) {
                this.data.description = this.ui.edtDescription.val();
                this.updateWizardButtons();
            },
            'click .js-add-custom-cond': function (e) {
                var s = getSeriesRow(e);
                this.data.selectedSeriesRow = s.idx;
                var series = this.data.series[s.idx];
                series.customConditions = series.customConditions || [];
                series.customConditions.push({
                    text: '',
                    value: '',
                    op: '',
                    color: nextColor(series.customConditions),
                });
                this.render();
            },
            'keyup .js-cond-text': function (e) {
                this.saveCondRow(e);
            },
            'change .js-cond-render': function (e) {
                this.saveCondRow(e);
                this.render();
            },
            'click .js-df-cond-up': function (e) {
                var row = getSeriesCondRow(e);
                this.data.selectedSeriesRow = row.series.idx;
                var series = this.data.series[row.series.idx];
                var myRow = series.customConditions[row.idx];
                var prevRow = series.customConditions[row.idx - 1];

                series.customConditions[row.idx] = prevRow;
                series.customConditions[row.idx - 1] = myRow;
                this.render();
            },
            'click .js-df-cond-down': function (e) {
                var row = getSeriesCondRow(e);
                this.data.selectedSeriesRow = row.series.idx;
                var series = this.data.series[row.series.idx];
                var myRow = series.customConditions[row.idx];
                var nextRow = series.customConditions[row.idx + 1];
                if (nextRow == undefined) return;

                series.customConditions[row.idx] = nextRow;
                series.customConditions[row.idx + 1] = myRow;
                this.render();
            },
            'click .js-df-cond-delete': function (e) {
                var row = getSeriesCondRow(e);
                this.data.selectedSeriesRow = row.series.idx;
                var series = this.data.series[row.series.idx];
                series.customConditions.splice(row.idx, 1);
                this.render();
            },
            'change .js-device-color': function (e) {
                this.saveDeviceColor(e);
            },
        }),

        saveDeviceColor: function (e) {
            var s = getSeriesRow(e);
            var series = this.data.series[s.idx];
            var deviceID = parseInt($(e.currentTarget).data('device-id'));
            var color = $(e.currentTarget).css('background-color');
            series.deviceColorMap[deviceID] = color;
        },

        saveCondRow: function (e) {
            var row = getSeriesCondRow(e);
            this.data.selectedSeriesRow = row.series.idx;
            var cond = this.data.series[row.series.idx].customConditions[row.idx];
            cond.text = row.find('.js-cond-text').val();
            cond.op = row.find('select.js-cond-op').val();
            cond.color = row.find('button.js-color').css('background-color');
        },

        checkModeDisabled: function (mode, isDeviceData, idx) {
            var disabled = (mode == 4 || mode == 5) && !isDeviceData;
            var modeProp = Consts.DeviceReportModeProp[mode] || {};
            // CSV
            if (this.options.reportFormat == 1) {
                disabled = disabled || !modeProp.isTable;
                disabled = disabled || (mode == 3 && (idx > 0 || this.data.series.length > 1));
            }

            disabled = disabled || (mode == 5 && (!this.selectedDevices || this.selectedDevices.length != 1));
            disabled =
                disabled ||
                ((mode == 4 || mode == 6) &&
                    (!this.selectedDevices ||
                        this.selectedDevices.length == 0 ||
                        this.selectedDevices.length > maxDeviceCount));

            return disabled;
        },

        finalizeSeries: function () {
            var self = this;
            var seriesMap = {};
            var fields = AppState.uniqueFields();
            _.each(this.data.series, function (item, idx) {
                var isDeviceData = hasAggregation(item.value, fields);
                var key = item.value + item.aggregation;
                item.idx = idx;
                seriesMap[key] = true;

                if (item.name == '') {
                    self.setSeriesDefaultName(item);
                }

                item.noUp = idx == 0;
                item.noDown = idx == self.data.series.length - 1;
                item.noCustomCond = item.mode == 0 || item.mode == 6;
                item.noColorSelect = item.mode == 3; // no color selection by histogram table
                item.noComparison = item.mode == 4 || item.mode == 5;
                item.modes = Misc.selectWhere(Consts.DeviceReportModes, undefined, function (x) {
                    return {
                        id: x.id,
                        name: x.name,
                        icon: x.icon,
                        disabled: self.checkModeDisabled(x.id, isDeviceData, idx),
                    };
                });

                _.each(item.customConditions, function (cc, cidx) {
                    cc.idx = cidx;
                    cc.fvid = 'fv' + item.idx + '-' + cidx;
                    cc.noUp = cidx == 0;
                    cc.noDown = cidx == item.customConditions.length - 1;
                    if (item.noComparison) {
                        cc.op = '=';
                    }
                });

                var usedColors = [];
                item.deviceColors = [];
                if ((item.mode == 4 || item.mode == 5) && self.selectedDevices) {
                    item.deviceColors = Misc.selectWhere(self.selectedDevices.models, undefined, function (dev, idx) {
                        item.deviceColorMap = item.deviceColorMap || {};
                        var deviceID = dev.id;
                        if (!item.deviceColorMap[deviceID]) {
                            var nc = nextColor(usedColors);
                            usedColors.push({ color: nc });
                            item.deviceColorMap[deviceID] = nc;
                        }

                        return {
                            deviceName: dev.get('name'),
                            deviceID: deviceID,
                            color: item.deviceColorMap[dev.get('id')],
                        };
                    });
                }
            });
        },

        saveSorting: function (e) {
            this.data.sortcol = $('select.js-sort-col').val();
            this.data.sortdesc = $('.js-sort-desc').prop('checked');
            this.data.limit = $('.js-limit').val();
        },

        saveSeriesRow: function (e, setDefaultName, setMode) {
            var s = getSeriesRow(e);
            var fields = AppState.uniqueFields();
            var series = this.data.series[s.idx];
            var newValue = s.find('select.js-value').val();
            var prevMode = series.mode;

            series.name = s.find('.js-name').val();
            series.unit = s.find('.js-unit').val();
            series.aggregation = s.find('select.js-aggregation').val();
            series.value = newValue;
            series.hasAggregation = hasAggregation(series.value, fields);
            series.mode = parseInt(s.find('select.js-mode').val());
            series.customCond = s.find('.js-cond-custom').prop('checked');
            if (!series.customCond) {
                series.customConditions = [];
            }

            if (setMode && (Consts.DeviceReportModeProp[series.mode] || {}).isGlobal && prevMode != series.mode) {
                _.each(this.data.series, function (seriesItem) {
                    if ((Consts.DeviceReportModeProp[seriesItem.mode] || {}).isGlobal) seriesItem.mode = series.mode;
                });
            }

            var aggText = this.getAggregationText(series);

            if ((!series.aggregation || !aggText) && series.hasAggregation) {
                series.aggregation = Consts.AggregationDeviceReport[0].id;
            }

            if (setDefaultName) {
                this.setSeriesDefaultName(series);
            }

            if (series.customCond && AppState.canEnumFieldValues(series.value) && !this.fieldValuesEnum[series.value]) {
                this.loadFieldValuesEnum([series.value]);
            }

            this.data.selectedSeriesRow = s.idx;
        },

        loadFieldValuesEnum: function (fields) {
            var self = this;

            fields = _.unique(fields);
            $.when
                .apply(
                    $,
                    _.map(fields, function (f) {
                        return App.request('values:content', f);
                    })
                )
                .done(function () {
                    for (var i = 0; i < arguments.length; i++) {
                        self.fieldValuesEnum[fields[i]] = arguments[i];
                    }
                    self.render();
                });
        },

        serializeData: function () {
            // set idx at all series and check duplicities
            this.finalizeSeries();
            var self = this;
            var data = this.base.serializeData();
            data.series = this.data.series;
            data.noAdd = this.options.reportFormat == 1 && this.data.series.length > 0 && this.data.series[0].mode == 3;
            data.availableValues = Misc.selectWhere(AppState.uniqueFields(), function (item) {
                return Consts.FieldInfo.NoReport.indexOf(item.id) == -1;
            });
            _.each(data.availableValues, function (e) {
                e.name = I18N.DATAPOINT((e.categories || [''])[0], e.name);
            });
            data.availableValues = _.sortBy(data.availableValues, function (e) {
                return e.name;
            });

            var mailboxes = this.options.mailboxes ? this.options.mailboxes.toJSON() : [];

            data.errors = this.errors;
            data.comparison = Consts.FilterComparison.concat(['']);
            data.aggregations = Consts.AggregationDeviceReport;
            data.name = this.data.name;
            data.description = this.data.description;
            data.sortcol = this.data.sortcol;
            data.sortdesc = this.data.sortdesc;
            data.limit = this.data.limit;
            data.interval = this.data.interval;
            data.errors = this.errors;
            data.mailboxes = mailboxes;
            data.periods = Consts.ReportPeriods;
            data.formats = Consts.ReportFormats;
            data.selectedSeriesRow = this.data.selectedSeriesRow;
            data.fieldValuesEnum = this.fieldValuesEnum;

            _.each(data.series, function (s, idx) {
                var mode = s.mode || 0;
                s.idx = idx;
                s.type_icon = Misc.reportModeIconByID(mode);
                data.canSort = data.canSort || mode == 0;
                self.fixCustomCondValues(s, data.fieldValuesEnum);
            });

            return data;
        },

        fixCustomCondValues: function (series, enumValues) {
            if (!enumValues || !enumValues[series.value] || enumValues[series.value].length == 0) return;
            enumValues = enumValues[series.value];
            _.each(series.customConditions, function (cond) {
                if (_.indexOf(enumValues, cond.value) < 0) {
                    cond.value = enumValues[0];
                }
            });
        },

        getReportPageIdx: function () {
            return this.filterConfig.selectionTab + 2;
        },

        getSeriesPageIdx: function () {
            return this.filterConfig.selectionTab + 1;
        },

        wizardDone: function () {
            var self = this;
            var isValid = this.wizardValidate(function (frm) {
                var self2 = this;
                this.required('name', frm.data.name, I18N.TR('Der Name muss angegeben werden.'), frm.ui.edtName, {
                    page: self.getReportPageIdx(),
                });

                this.maxLen(
                    'name',
                    frm.data.name,
                    100,
                    I18N.TR('Der Name darf nicht länger als 100 Zeichen sein.'),
                    frm.ui.edtName,
                    { page: self.getReportPageIdx() }
                );

                _.each(frm.data.series, function (ser, idx) {
                    self2.maxLen(
                        'error',
                        ser.name,
                        40,
                        I18N.TR('Die Beschriftung eines Wertes darf nicht länger als 40 Zeichen sein.'),
                        $('#js-series-name-' + idx),
                        { page: self.getReportPageIdx() }
                    );
                });

                this.maxLen(
                    'description',
                    frm.data.description,
                    4000,
                    I18N.TR('Die Beschreibung darf nicht länger als 4000 Zeichen sein.'),
                    frm.ui.edtDescription,
                    { page: self.getReportPageIdx() }
                );

                this.emptyOrNumber(
                    'error',
                    frm.data.limit,
                    I18N.TR('Top X muss eine Zahl oder leer sein.'),
                    $('.js-limit'),
                    { page: self.getReportPageIdx() }
                );

                var v = this;
                _.each(self.data.series, function (ser, idx) {
                    _.each(ser.customConditions, function (cc, cidx) {
                        v.required(
                            'error',
                            cc.text,
                            I18N.TR('Der Text muss bei allen Optionen angegeben werden.'),
                            $('.js-text-cond-' + idx + '-' + cidx),
                            { page: self.getSeriesPageIdx() }
                        );
                    });
                });
            });
            if (isValid && this.cb) {
                this.setError(undefined);

                this.options.model.set('name', this.data.name);
                this.options.model.set('description', this.data.description);
                this.options.model.set('filter', this.filterIntf.filter);

                var saveSortSettings = false;
                this.options.model.set(
                    'fields',
                    _.map(this.data.series, function (item) {
                        saveSortSettings = saveSortSettings || item.mode == 0;
                        return {
                            id: item.id,
                            aggregation: item.hasAggregation ? item.aggregation : '',
                            name: item.name,
                            unit: item.unit,
                            value: item.value,
                            mode: item.mode,
                            device_color_map: toDeviceColorMap(item.deviceColorMap),
                            display_values: _.map(item.customConditions, function (m) {
                                return {
                                    text: m.text,
                                    value: '' + m.value,
                                    op: m.op,
                                    color: m.color.replace(/[^\d,]/g, ''),
                                };
                            }),
                        };
                    })
                );

                this.options.model.set('limit', saveSortSettings ? parseInt(this.data.limit) : 0);
                this.options.model.set('sort_desc', saveSortSettings ? this.data.sortdesc : undefined);
                this.options.model.set('sort_col', saveSortSettings ? this.data.sortcol : undefined);

                this.cb(this.options.model);
            }
        },

        onRender: function () {
            $('.modal-dialog').addClass('modal-lg');
            FieldValue.attachEvents();
            Misc.initTimePicker();
            Misc.initDatePicker();
            Misc.initSelectPicker({ visibleOnly: true });
            setTimeout(function () {
                Misc.initColorButtons();
                Misc.initSelectPicker();
            });
        },

        doWizardNext: function () {
            var self = this;
            if (this.selected == this.filterConfig.selectionTab) {
                this.selectedDevices = [];
                if (this.filterConfig.selection && this.filterConfig.selection.selectionID) {
                    // get the list of devices with current filter
                    $.when(
                        App.request('device:list', {
                            filterParams: { limit: maxDeviceCount + 1, onError: 'emptyList' },
                            filter: this.filterIntf.filter,
                        })
                    ).done(function (list) {
                        self.selectedDevices = list.items;
                        self.backgroundTasks.done(function () {
                            self.base.doWizardNext();
                        }, self);
                    });
                    return;
                }
            }
            this.backgroundTasks.done(function () {
                this.base.doWizardNext();
            }, this);
        },

        canWizardFinish: function () {
            if (!this.base.canWizardFinish()) return false;
            return this.data.name != undefined && this.data.name.length > 0 && this.data.series.length > 0;
        },

        getAggregationText: function (series) {
            return Misc.selectWhereFirst(
                Consts.AggregationDeviceReport,
                function (item) {
                    return item.id == series.aggregation;
                },
                'name'
            );
        },

        setSeriesDefaultName: function (series) {
            var cols = AppState.uniqueFields();

            var seriesInfo = Misc.selectWhereFirst(cols, function (item) {
                return item.id == series.value;
            });

            var name = I18N.DATAPOINT((seriesInfo.categories || [''])[0], seriesInfo.name);
            var aggregation = hasAggregation(series.value, cols) ? ' - ' + this.getAggregationText(series) : '';

            series.name = name + aggregation;
        },
    },
    'DeviceReportDialogView'
);

module.exports = DeviceReportDialogView;
